import fetch from '@jarvis.oddle/core/tools/fetch'
import { newrelicPath } from './server'

const makeOptions = ({ method = 'GET', payload, include = true, req }) => {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  }

  return options
}

export const postLogApi = async ({ req, origin, apiRoot, payload }) => {
  const response = await fetch(
    `${origin(req)}${apiRoot}${newrelicPath}`,
    makeOptions({ method: 'POST', payload }),
    true
  )
  return response
}
